import type { ErrorContext, ErrorService } from '#src/telemetry/errors/error_service.ts';
import * as Sentry from '@sentry/react';

export class SentryErrorService implements ErrorService {
  captureError(error: unknown, ctx: ErrorContext): void {
    try {
      Sentry.captureException(error, {
        extra: {
          ...ctx.extra,
          message: ctx.message,
        },
      });
    } catch (sentryError) {
      // If Sentry itself throws an error, swallow the error to prevent infinite loops.
      // Nothing can be done at this point other than log to the console.
      console.error('error service: captureException failed', sentryError);
      console.error('error service: original error', error, ctx);
    }
  }

  captureWarning(message: string): void {
    try {
      Sentry.captureMessage(message, { level: 'warning' });
    } catch (sentryError) {
      // If Sentry itself throws an error, swallow the error to prevent infinite loops.
      // Nothing can be done at this point other than log to the console.
      console.warn('error service: captureWarning failed', sentryError);
      console.warn('error service: original warning', message);
    }
  }
}
